<template>
  <div id="app">
    
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
   
    <!-- <div class="nav-bar">
      <div class="nav-item" :class="{active: currentPath == 'index'}">
        <router-link  class="link" to="/index">
          <i class="icon-center"></i>
          <span>市政大厅</span>
        </router-link>
      </div>
      <div class="nav-item" :class="{active: currentPath == 'matrix'}">
        <router-link  class="link" to="/matrix">
          <i class="icon-matrix"></i>
          <span>微矩阵</span>
        </router-link>
      </div>
      <div class="nav-item" :class="{active: currentPath == 'news'}">
        <router-link  class="link" to="/news">
          <i class="icon-news"></i>
          <span>小布服务站</span>
        </router-link>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  data(){
    return {
      currentPath: 'index'
    }
  },
  created(){
    this.currentPath = this.$route.name
    this.share()
  },
  watch: {
    '$route'(value){
      this.currentPath = value.name
    }
  },
  methods: {
    share(){
      axios({
        url: '/cdfb/Index/user/getSignPackageByApi.html'
      }).then(rep => {
        const data = rep.data.data
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名
          jsApiList: ["hideOptionMenu", "updateAppMessageShareData", "updateTimelineShareData","onMenuShareTimeline", "onMenuShareAppMessage"] // 必填，需要使用的JS接口列表
        })

        window.wx.ready(()=>{
          const title = '小布服务'
          const desc = '掌上办事通道'
          const img  = 'https://images.cdsb.com/Uploads/micropub/20210914/6140681937770.jpg'
          const url = 'https://jumpapp.cdsb.com/cdfb/public/web/xiaobu.html'

          window.wx.updateAppMessageShareData({ 
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
              // 设置成功
            }
          })
          window.wx.updateTimelineShareData({ 
            title: title, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
              // 设置成功
            }
          })

          window.wx.onMenuShareTimeline({
            title: title, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
            // 用户点击了分享后执行的回调函数
            }
          })

          window.wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: img, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
            }
          })




        }) 
      })
    }
  }
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  font-family: -apple-system, -apple-system-font, "Microsoft YaHei", Arial, sans-serif;
}
a{
  text-decoration: none;
  color: inherit;
}
#app{
  width: 100vw;
  overflow-x: hidden;
  overflow-y: auto;
}
.nav-bar{
  position: fixed;
  left: 0;
  bottom: 0;
  height: 2.5rem;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  background: #fff;
  border-top: 1px solid #F1F2F4;
  padding-bottom: calc(.1rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(.1rem + env(safe-area-inset-bottom));
}
.nav-item{
  font-size: .5rem;
  color: #868B95;
}
.nav-item .link{
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 0 .3rem;
}
.nav-item.active{
  color: #4186E6;
}
.nav-item .link span{
  transform: scale(.9);
}
.icon-center{
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  margin: .3rem 0 .05rem;
  background: url(./assets/icon-center.png) 100%/100%;
}
.nav-item.active .icon-center{
  background: url(./assets/icon-center-ed.png) 100%/100%;
}
.icon-shimingyun{
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  margin: .3rem 0 .05rem;
  background: url(./assets/icon-shimingyun.png) 100%/100%;
}
.icon-news{
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  margin: .3rem 0 .05rem;
  background: url(./assets/icon-news.png) 100%/100%;
}
.nav-item.active .icon-news{
  background: url(./assets/icon-news-ed.png) 100%/100%;
}
.icon-matrix{
  display: block;
  width: 1.2rem;
  height: 1.2rem;
  margin: .3rem 0 .05rem;
  background: url(./assets/icon-matrix.png) 100%/100%;
}
.nav-item.active .icon-matrix{
  background: url(./assets/icon-matrix-ed.png) 100%/100%;
}
.slide-fade-enter-active {
  transition: all .2s ease;
}
/*.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}*/
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(2rem);
  opacity: 0;
}
</style>
